import { Share2, Link as LinkIcon } from "lucide-react";
import { toast } from "sonner";

export const ShareButtons = ({ title }) => {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const enc = encodeURIComponent;
  const links = [
    ["Reddit", `https://www.reddit.com/submit?url=${enc(url)}&title=${enc(title)}`],
    ["Facebook", `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`],
    ["X", `https://twitter.com/intent/tweet?url=${enc(url)}&text=${enc(title)}`],
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied");
    } catch (e) {
      toast.error("Could not copy link");
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-buttons">
      <span className="text-xs text-muted-foreground flex items-center gap-1.5 mr-1"><Share2 size={13} /> Share</span>
      {links.map(([name, href]) => (
        <a key={name} href={href} target="_blank" rel="noopener noreferrer" data-testid={`share-${name.toLowerCase()}`}
          className="text-xs px-3 py-1.5 rounded-full border border-border text-muted-foreground hover:text-foreground hover:border-primary/50 transition-colors">
          {name}
        </a>
      ))}
      <button onClick={copy} data-testid="share-copy-link"
        className="text-xs px-3 py-1.5 rounded-full border border-border text-muted-foreground hover:text-foreground hover:border-primary/50 transition-colors flex items-center gap-1.5">
        <LinkIcon size={11} /> Copy link
      </button>
    </div>
  );
};
